import { render, staticRenderFns } from "./huisartsCuForm.vue?vue&type=template&id=2a4a1c5c&scoped=true"
import script from "./huisartsCuForm.vue?vue&type=script&lang=js"
export * from "./huisartsCuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a1c5c",
  null
  
)

export default component.exports